import styled from "styled-components";

export const Wrapper = styled.div`
.bdr{border:1px solid red !important;}

.billing-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0px 18px;
  }

  .billing-title {
    font-size: 22px;
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.02em;
  }

  .billing-subtitle {
    margin-top: 4px;
    font-size: 13px;
    color: #6b7280;
  }

  .billing-status {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(6px);
    border: 1px solid rgba(229, 231, 235, 0.9);
    box-shadow: 0 6px 18px rgba(17, 24, 39, 0.06);
    white-space: nowrap;
  }
  .billing-status__icon {
    color: #22c55e;
    font-size: 16px;
  }
  .billing-status__text {
    color: #374151;
    font-size: 12px;
  }
  .billing-status__dot {
    opacity: 0.6;
    margin: 0 6px;
  }

  .billing-card {
    border-radius: 14px;
    overflow: hidden;
  }

  .billing-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .billing-section-title {
    font-size: 17px;
    font-weight: 800;
    color: #111827;
  }
  .billing-section-subtitle {
    margin-top: 2px;
    font-size: 12px;
    color: #6b7280;
  }

  .billing-btn {
    // border-radius: 10px;
    font-weight: 600;
    font-size: 13px;
  }

  .billing-link.ant-btn-link {
    padding: 0;
    height: auto;
    font-weight: 700;
    color: #f45b68;
  }

  .billing-tag {
    border-radius: 999px;
    font-weight: 700;
    background: #fff1f2;
    border-color: #fecdd3;
    color: #be123c;
  }

  .billing-amount {
    font-weight: 800;
    color: #111827;
  }

  .billing-period {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
  .billing-period__label {
    font-size: 12px;
    color: #6b7280;
    font-weight: 700;
  }
  .billing-period__toggle {
    display: inline-flex;
    background: #f3f4f6;
    border-radius: 999px;
    padding: 3px;
    border: 1px solid #e5e7eb;
  }
  .billing-pill {
    border: 0;
    background: transparent;
    border-radius: 999px;
    padding: 6px 10px;
    font-size: 12px;
    font-weight: 800;
    color: #6b7280;
    cursor: pointer;
  }
  .billing-pill.is-active {
    background: #ffffff;
    color: #111827;
    box-shadow: 0 6px 14px rgba(17, 24, 39, 0.08);
  }

  .billing-plans-grid {
    // display: grid;
    // grid-template-columns: 1.05fr 1fr;
    // gap: 18px;
  }

  .billing-current {
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    background: linear-gradient(180deg, #ffffff 0%, #fff7f8 100%);
    padding: 16px;
    box-shadow: 0 10px 24px rgba(17, 24, 39, 0.05);
    min-height: 303px;
  }

  .billing-current__badge {
    display: inline-flex;
    padding: 6px 10px;
    border-radius: 999px;
    background: #ff4d4f2e;
    color: #374151;
    font-size: 12px;
    font-weight: 900;
  }
  .billing-current__name {
    margin-top: 10px;
    font-size: 18px;
    font-weight: 900;
    color: #111827;
  }
  .billing-current__price {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 900;
    color: #111827;
  }
  .billing-current__price span {
    font-weight: 700;
    color: #6b7280;
    margin-left: 4px;
    font-size: 12px;
  }
  .billing-current__desc {
    margin-top: 6px;
    font-size: 12px;
    color: #6b7280;
    font-weight: 600;
  }
  .billing-current__actions {
    margin-top: 12px;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .billing-hint {
    margin-top: 10px;
    font-size: 12px;
    color: #6b7280;
    line-height: 1.5;
  }

  .billing-available {
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    background: #ffffff;
    padding: 14px 14px 10px;
  }
  .billing-available__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }
  .billing-available__title {
    font-size: 14px;
    font-weight: 900;
    color: #111827;
  }
  .billing-available__nav {
    display: inline-flex;
    gap: 8px;
  }
  .billing-icon-btn.ant-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-color: #e5e7eb;
  }

  .billing-scroll {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(230px, 1fr);
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 10px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }
  .billing-scroll::-webkit-scrollbar {
    height: 10px;
  }
  .billing-scroll::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 999px;
  }
  .billing-scroll::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 999px;
  }

  .billing-plan {
    scroll-snap-align: start;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    padding: 14px;
    background: #ffffff;
    box-shadow: 0 10px 18px rgba(17, 24, 39, 0.04);
  }
  .billing-plan.is-highlighted {
    border-color: rgba(244, 91, 104, 0.35);
    box-shadow: 0 16px 28px rgba(244, 91, 104, 0.12);
  }
  .billing-plan__name {
    font-size: 14px;
    font-weight: 900;
    color: #ff4d4f;
  }
  .billing-plan__price {
    margin-top: 6px;
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
  .billing-plan__priceValue {
    font-size: 20px;
    font-weight: 950;
    color: #111827;
  }
  .billing-plan__priceUnit {
    font-size: 12px;
    font-weight: 700;
    color: #6b7280;
  }
  .billing-plan__perks {
    margin: 10px 0 12px;
    padding: 0;
    list-style: none;
    display: grid;
    gap: 8px;
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
  }
  .billing-plan__perks li {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }
  .billing-check {
    width: 16px;
    height: 16px;
    border-radius: 999px;
    background: rgba(34, 197, 94, 0.14);
    border: 1px solid rgba(34, 197, 94, 0.3);
    position: relative;
    margin-top: 1px;
    flex: 0 0 16px;
  }
  .billing-check:after {
    content: "";
    position: absolute;
    inset: 4px 5px 5px 4px;
    border-right: 2px solid #16a34a;
    border-bottom: 2px solid #16a34a;
    transform: rotate(40deg);
  }
  .billing-plan__cta {
    width: 100%;
    font-size: 13px;
    font-weight: 600;
  }

  .billing-payments-grid {
    display: grid;
    grid-template-columns: 1.4fr 0.9fr;
    gap: 14px;
  }

  .billing-payCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 14px;
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    background: #ffffff;
  }
  .billing-payCard.is-default {
    background: linear-gradient(180deg, #ffffff 0%, #fff7f8 100%);
    border-color: rgba(244, 91, 104, 0.25);
  }
  .billing-payCard__left {
    display: flex;
    gap: 14px;
    min-width: 0;
    align-items: center;
  }
  .billing-payCard__brand {
    width: 56px;
    height: 38px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 900;
    background: #f3f4f6;
    color: #111827;
    flex: 0 0 56px;
    font-size: 12px;
  }
  .billing-payCard__meta {
    min-width: 0;
  }
  .billing-payCard__number {
    font-size: 12px;
    font-weight: 900;
    color: #111827;
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
  }
  .billing-defaultTag {
    display: inline-flex;
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 900;
    background: #ecfdf5;
    border: 1px solid #bbf7d0;
    color: #166534;
  }
  .billing-payCard__name {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 560px;
  }
  .billing-payCard__actions {
    display: inline-flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .billing-billingInfo {
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    background: linear-gradient(180deg, #ffffff 0%, #fff7f8 100%);
    padding: 14px;
    height: 100%;
  }
  .billing-billingInfo__title {
    font-size: 13px;
    font-weight: 900;
    color: #111827;
    margin-bottom: 10px;
  }
  .billing-billingInfo__row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px dashed #e5e7eb;
  }
  .billing-billingInfo__row:last-of-type {
    border-bottom: 0;
    margin-bottom: 10px;
  }
  .billing-billingInfo__label {
    font-size: 12px;
    color: #6b7280;
    font-weight: 700;
  }
  .billing-billingInfo__value {
    font-size: 12px;
    color: #111827;
    font-weight: 900;
    text-align: right;
  }

  @media (max-width: 1200px) {
    .billing-plans-grid {
      grid-template-columns: 1fr;
    }
    .billing-payments-grid {
      grid-template-columns: 1fr;
    }
    .billing-header {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
